<template>
  <div v-if="isMounted">
    <template v-if="!showNewAccount">
      <!-- REGISTRAR ABONO -->
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div class="vx-row">
            <div :class="colClassFull">
              <label class="vs-input--label">Cuenta de origen *</label>
              <v-select class="vs-custom" name="fundAccount" :class="{
                'has-error': hasError('fundAccount'),
                'is-success': isSuccess('fundAccount'),
              }" v-model.lazy="fundAccount" v-validate="requiredRules" :options="collections.accounts"
                :reduce="(item) => item.value" :clearable="false" placeholder="Selecciona una opción" :searchable="false">
              </v-select>
              <v-error v-if="hasError('fundAccount')" :error="errorText('fundAccount')" />
              <div class="flex mt-3">
                <feather-icon icon="PlusCircleIcon" svgClasses="w-5 h-5" class="text-dark" />
                <a href="#" class="black ml-2" @click="showNewAccount=true">Agregar cuenta</a>
              </div>
            </div>
            <div :class="colClass">
              <label class="vs-input--label">Monto *</label>
              <vs-input class="investment-input w-full" type="text" v-model="fundAmountMoney" v-money="money"
                name="fundAmountMoney" v-validate="requiredRules" :min="0" autocomplete="off" />
              <v-error v-if="hasError('fundAmountMoney')" :error="errorText('fundAmountMoney')" />
            </div>
            <div :class="colClass">
              <label class="vs-input--label">Divisa *</label>
              <v-select class="vs-custom" name="fundCurrency" :class="{
                'has-error': hasError('fundCurrency'),
                'is-success': isSuccess('fundCurrency'),
              }" v-model.lazy="fundCurrency" v-validate="requiredRules" :options="collections.currencies"
                :reduce="(item) => item.value" :clearable="false" placeholder="Selecciona una opción" :searchable="false">
              </v-select>
              <v-error v-if="hasError('fundCurrency')" :error="errorText('fundCurrency')" />
            </div>
          </div>
          <div class="vx-row">
            <div :class="colClassFull">
              <document-upload-lite :accepts="['pdf', 'png', 'jpg', 'jpeg']" name="Comprobante de transferencia"
                check-url="/" view-url="/" download-url="/" :upload-url="uploadUrl" width="1/2" :canUpload="canUploadFile"
                @on-success="onSuccessEvent" />
            </div>
          </div>
          <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle" class="mb-5" color="danger">
            <span class="font-regular">{{ errorMssg }}</span>
          </vs-alert>
          <div class="vx-row">
            <div v-if="!createdInternationalTransferId" class="vx-col md:w-1/2 sm:w-full w-full">
              <vs-button @click="saveDataForm">Registrar abono</vs-button>
            </div>
          </div>
        </div>
      </div>
      <!-- TABLA DE ABONOS REGISTRADOS -->
      <div class="vx-row mt-base">
        <div class="vx-col w-full md:w-3/4">
          <h4>Abonos en proceso</h4>
          <!-- tabla de abonos en proceso -->
          <div class="vx-row mt-6 mb-2">
            <div class="vx-col xxl:w-2/3 lg:w-full w-full">
              <div class="data-list-container data-list-list-view data-list-rows vs-con-loading__container" id="main-div">
                <vs-table class="mt-1" ref="accountsTable" :data="investorInternationalTransfers"
                  noDataText="No hay abonos registrados">
                  <template slot="thead" color="dark">
                    <vs-th class="bold">Fecha de solicitud</vs-th>
                    <vs-th class="bold">Monto</vs-th>
                    <vs-th class="bold">Divisa</vs-th>
                    <vs-th class="bold">Cuenta origen</vs-th>
                    <vs-th class="bold">Estado</vs-th>
                    <vs-th class="bold">Última fecha</vs-th>
                    <vs-th class="bold"></vs-th>
                  </template>
  
                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{  regularDateFormat(tr.deposit_request_timestamp) }}
                        </vs-td>
                        <vs-td>
                          {{ format_price(tr.amount) }}
                        </vs-td>
                        <vs-td>
                          {{ tr.currency }}
                        </vs-td>
                        <vs-td>
                          ****{{ visibleOnlyLastNChars(tr.account) }}
                        </vs-td>
                        <vs-td>
                          {{ tr.status }}
                        </vs-td>
                        <vs-td>
                          {{  regularDateFormat(tr.verified_timestamp) }}
                        </vs-td>
                        <vs-td>
                          <feather-icon icon="Trash2Icon" :svgClasses="klassFull" class="ml-5"
                            @click.stop="deleteTransferRequest(tr)" />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
              <p class="mt-5">
                <vs-alert size="small" icon-pack="feather" icon="icon-info" class="h-full" color="dark">
                  Puedes consultar tus abonos exitosos en <a href="/inversionista/mis-movimientos" class="underline black" >Mis movimientos</a>. Si tu abono fue rechazado, consulta tu correo para conocer el motivo y las soluciones.
                </vs-alert>
              </p>
            </div>
          </div>
          <!-- fin tabla abonos en proceso -->
        </div>
      </div>
    </template>
    <template v-else>
      <international-bank-accounts class="mt-4" :is-moral="false" :person-type="2" :user-id="UserId" 
      :has-backoffice-access="false" :user-data="userDataBase" :only-form="true"/>
    </template>
  </div>
</template>

<script>
import DocumentUploadLite from "@components/upload/DocumentUploadLite";
import { VMoney } from 'v-money'
import currencyHelper from "@mixins/currencyHelper";
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import { BankAccountStatus } from "@/bl/BankAccountStatus";
import InternationalBankAccounts from "@components/investor/bank-accounts/InternationalBankAccounts";

export default {
  name: "RegisterInternationalFund",
  components: {
    DocumentUploadLite, 
    InternationalBankAccounts
  },
  mixins: [currencyHelper, formatHelper,dateHelper],
  directives: { money: VMoney },
  props: {
    userAccountsProp: { type: Array, default: [] },
    userDataBase: { type: Object, default: [] },
  },
  data() {
    return {
      isMounted: false,
      fundAmountMoney: null,
      fundAccount: null,
      fundCurrency: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      investorInternationalTransfers: [],
      internationalTransferIdToDelete: null,
      createdInternationalTransferId: null,
      collections: {
        accounts: [],
        currencies: [],
      },
      onError: false,
      errorMssg: null,
      currentIdToDelete: null,
      requiredRules: "required",
      errorMssg: null,
      colClass: "vx-col lg:w-1/2 w-full mb-5",
      colClassFull: "vx-col w-full mb-5",
      requiredPlaceholder: "(Requerido)",
      klassBase: "h-5 w-5 stroke-current",
      klassFull: "h-5 w-5 stroke-current hover:text-primary cursor-pointer",
      showNewAccount: false,
    }
  },
  async beforeMount() {
    this.showLoading(true)
    await this.getCollections();
    this.showLoading(false);
  },
  async mounted() {
    await this.setInitialState();
  },
  computed: {
    uploadUrl() {
      if (this.createdInternationalTransferId) {
        return `investor/international-transfers/${this.createdInternationalTransferId}/upload`;
      }
      return "/";
    },
    canUploadFile() {
      return !!this.createdInternationalTransferId;
    }
  },
  methods: {
    async refreshAccounts() {
      await this.getUserAccounts();
    },
    async getUserAccounts(fromApi = false) {
      try {
        let accs = [];
        if (fromApi) {
          const res = await axios.get('api/app/bank-account');
          accs = res.data;
        } else {
          accs = this.userAccountsProp;
        }
        let formattedAccounts = [];
        accs.forEach(f => {
          let nacc = this.getFormattedAccount(f);
          formattedAccounts.push(nacc);
        });

        let validAccounts = formattedAccounts.filter(f => f.is_verified);
        validAccounts.sort(function (a, b) {
          if (a.is_default) {
            return -1
          }
          else if (b.is_default) {
            return 1;
          }
          return 0;
        });
        validAccounts.forEach(opt => {
          this.collections.accounts.push({ value: parseInt(opt.id), label: opt.clabe });
        })
      }
      catch (e) {
      }
    },
    async getInvestorInternationalTransfers() {
      try {
        let accs = [];
        const res = await axios.get(`api/v2/investor/international-transfers/admin`);
        accs = res.data;
        this.investorInternationalTransfers = accs;
      }
      catch (e) {
      }
    },
    getFormattedAccount(f) {
      let nacc = {
        id: f.id,
        bank_id: f.bank_id,
        is_default: f.is_default === 1,
        is_verified: f.verified === BankAccountStatus.VERIFIED
      }

      nacc.bank_name = f.bank.name;

      if (f.bic_swift) {
        nacc.clabe = f.bic_swift;
      }
      else {
        if (f.iban) {
          nacc.clabe = f.iban;
        } else {
          nacc.clabe = f.routing_number;
        }
      }
      return nacc;
    },
    async setInitialState() {
      this.collections.accounts=[];
      this.currentIdToDelete=null;
      this.fundAccount = null;
      this.fundAmountMoney = 0;
      this.fundCurrency = null;
      this.createdInternationalTransferId = null;
      this.isMounted = false;
      this.showLoading(true)
      // await this.getCollections();
      let getAccounts = this.userAccountsProp.length == 0;
      await this.getUserAccounts(getAccounts);
      await this.getInvestorInternationalTransfers();
      this.showLoading(false);
      this.isMounted = true;
    },
    async getCollections() {
      try {
        let collectionsObjects = ['currencies'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await this.publicApiGet(`/api/v1/forms/getPublicFormCollections?${params}`);
        let colls = res.data;
        colls.currencies.forEach(opt => {
          this.collections.currencies.push({ value: parseInt(opt.id), label: opt.short_name });
        })
      }
      catch (e) {
      }
    },
    async saveDataForm() {
      this.errorMssg = null;
      if (!(await this.validateForm())) {
        return;
      }
      this.showLoading(true, "Guardando información...");
      try {
        let amount = this.unMoneyFormat(this.fundAmountMoney);
        let payload = {
          fund_account: this.fundAccount,
          fund_amount: amount,
          fund_currency: this.fundCurrency
        };
        const res = await axios.post(
          "/api/v2/investor/international-transfers/create",
          payload
        );
        this.successNotifDialog('Abono registrado', 'Ahora sube el comprobante de la transferencia para finalizar');
        this.createdInternationalTransferId = res.data.international_transfer_id;
        this.showLoading(false);
        this.$emit("updated", 1);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
    },
    async validateForm() {
      this.errorMssg = null;
      let amount = this.unMoneyFormat(this.fundAmountMoney);
      if (amount <= 0) {
        this.errorMssg = "Por favor ingresa un monto válido.";
        return false;
      }
      return this.$validator.validateAll();
    },
    async onSuccessEvent(res) {
      this.successNotif("Aviso", "Tu comprobante ha sido registrado exitosamente", 8000);
      this.userAccountsProp = [];
      await this.setInitialState();
    },
    clean() {
      this.onError = false
      this.errorMssg = null
    },
    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return ff && ff.required && ff.valid;
    },
    async deleteTransferRequest(tr) {
      this.currentIdToDelete = tr.id;
      let mssg = "¿Estás seguro de que deseas cancelar este abono? El monto será reembolsado a la cuenta de origen.\n\n";
      mssg += "Es posible que algunos bancos cobren comisiones por realizar transferencias internacionales, por lo que el reembolso que recibirás puede ser menor que el monto que transferiste.";

      this.confirmationDialog(this.doDeleteTransfer, "Cancelar abono", mssg, "Si", "No");
    },
    async doDeleteTransfer() {
      this.showLoading(true)
      try {
        let payload = { international_transfer_id: this.currentIdToDelete };
        await axios.post(`api/v2/investor/international-transfers/delete`, payload);
        this.successNotif("Transferencia eliminada", "La transferencia ha sido eliminada exitosamente", 8000);
        await this.setInitialState();
      }
      catch (e) {
        if (e && e.response && e.response.data && e.response.data.error) {
          this.errorNotifDialog("No ha sido posible eliminar la transferencia bancaria", e.response.data.error);
        }
        else {
          this.failedOperationNotif();
        }
      }
      this.showLoading(false)
    },
  }
}
</script>

<style scoped></style>